import React from 'react';
import Skeleton from './Skeleton';

const SkeletonList = ({ items = 5, showAvatars = true, className = '', ...props }) => {
  const renderListItem = index => (
    <div key={index} className="skeleton-client-item">
      {showAvatars && <Skeleton variant="avatar" className="skeleton-client-avatar" />}
      <div className="skeleton-client-info">
        <Skeleton variant="text" className="skeleton-client-name" />
        <Skeleton variant="text" className="skeleton-client-details" />
        <Skeleton variant="text" className="skeleton-client-meta" />
      </div>
      <div style={{ marginLeft: 'auto', display: 'flex', gap: '0.5rem' }}>
        <Skeleton variant="badge" />
        <Skeleton variant="button" className="small" />
      </div>
    </div>
  );

  return (
    <div className={`skeleton-list ${className}`} {...props}>
      {Array.from({ length: items }).map((_, index) => renderListItem(index))}
    </div>
  );
};

export default SkeletonList;
